import React, { useContext, useEffect, useState } from 'react';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import { FrameworkContext } from '../../../cnr/contexts/FrameworkContent';
import TiptapEditor from './TiptapEditor';

const HtmlEditor = (props) => {

  const { currentFip, handleEditor, handleUpdate } = props
  const { propname, label, value } = currentFip ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { frameworkLeftType, frameworkRightType } = framework_state ?? {}

  const [htmlValue, setHtmlValue] = useState()

  function removeExtraBreaks(html) {
    return html.replace(/(<br\s*\/?>\s*)+/g, '<br>');
  }

  useEffect(() => {
    const xxx = value ? removeExtraBreaks(value) : ' '
    setHtmlValue(xxx)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [value]);

  const handleEditorChange = (html) => {
    // let _html = ammendPTags(html)
    // _html = ammendGoogleSheetText(_html)
    // console.log('_html', _html) 
    setHtmlValue(html)
  }

  const handleOk = () => {
    const data = { propname, value: htmlValue }
    handleUpdate(null, data)
    handleEditor && handleEditor()
  }

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['clean']
    ],
  }

  // const formats = [
  //   'header',
  //   'bold', 'italic', 'underline', 'strike', 'blockquote',
  //   'list', 'bullet', 'indent',
  //   'link', 'image'
  // ]

  function extractAndFormat(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");

    // Extract image
    const img = doc.querySelector("img");
    const imgTag = img ? `\n\n<img src="${img.src}" width="${img.width}" height="${img.height}" alt="Some Image">\n\n\n` : "";

    // Extract and clean text
    const textContent = doc.body.textContent.replace(/\s+/g, ' ').trim();

    // Format output
    return `${imgTag}${textContent}`;
  }

  const editor = () => <TiptapEditor htmlValue={htmlValue} handleEditorChange={handleEditorChange} />

  const footer = () => <UiSaveButtons
    cancel={{ oc: handleEditor }}
    save={{ oc: handleOk, caption: 'OK', icon: 'check', color: 'blue' }}
  ></UiSaveButtons>

  const wrapper = () => <Wrapper
    content={htmlValue && editor()}
    footer={footer()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleEditor}
    topperCaption={'HTML Editor'}
    topperCaption2={label}
    isBack={true}
  ></FullPageWrapper>

  return frameworkRightType || frameworkLeftType ? wrapper() : fpw()
}

export default HtmlEditor
